import axios from "axios";
import { API_END_POINT } from "../../../constants/api";
import { returnErrors, clearErrors } from "../errorAction";
export const ADD_SIZER = "ADD_SIZER";
export const DELETE_SIZER = "DELETE_SIZER";
export const GET_SIZERS = "GET_SIZERS";
export const EDIT_SIZER = "EDIT_SIZER";

export function addSizer(params, token) {
  console.log(params);
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = JSON.stringify(params);
    axios
      .post(
        `${API_END_POINT}/api/sizer/sizer/register`,
        body,
        config
      )
      .then((res) => {
        dispatch({
          type: ADD_SIZER,
          payload: res.data,
        });
      })
      .then((data) =>
        dispatch(
          clearErrors("Sizer Add Successfully", 201, "ADD_SIZER_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data.message,
            err.response.status,
            "ADD_SIZER_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
export function getSizer(company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(
        `${API_END_POINT}/api/sizer/sizer/get/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: GET_SIZERS,
          payload: res.data,
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };
}
// export function deleteSizer(company_id,){
//   return dispatch()=>{
//     const config = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     };

//   }
// }

export function deleteSizer(sizer_id, company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .delete(
        `${API_END_POINT}/api/sizer/sizer/delete/${sizer_id}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: DELETE_SIZER,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Sizer Delete Successfully", 201, "DELETE_SIZER_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "DELETE_SIZER_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
export function editSizer(sizerUpdated, token, sizer_id) {
  console.log(sizerUpdated, sizer_id);
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    console.log(sizerUpdated, sizer_id);
    const body = JSON.stringify(sizerUpdated);
    axios
      .put(
        `${API_END_POINT}/api/sizer/sizer/update/${sizer_id}`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: EDIT_SIZER,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Sizer Update Successfully", 201, "UPDATE_SIZER_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data.message,
            err.response.status,
            "UPDATE_SIZER_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
